import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { PublicLayout } from '../components/layout/PublicLayout';
import { HeroSection, HowItWorks, FrameworkPreview } from '../components/home';
import { LoadingSpinner } from '../components/common/LoadingSpinner';

export function HomePage() {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-navy">
        <LoadingSpinner message="Loading..." />
      </div>
    );
  }

  if (isAuthenticated) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <PublicLayout>
      <HeroSection />
      <HowItWorks />
      <FrameworkPreview />

      <footer className="py-12 px-6 border-t border-wolf-700/50">
        <div className="max-w-6xl mx-auto text-center">
          <p className="text-wolf-500 text-sm">
            &copy; {new Date().getFullYear()} Catalyst. All rights reserved.
          </p>
        </div>
      </footer>
    </PublicLayout>
  );
}
